
export default class CookieController {
    static readCookie (cookie_name : string) : any {
        var nameEQ = cookie_name + "=",
            ca = document.cookie.split(';'),
            count = ca.length,
            i,
            c;
        for (i=0;i < count;i++) {
            c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1,c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length,c.length);
            }
        }
        return null;
    }
    static getMailByMpopCookie () {
        var cookie_name = 'Mpop',
            mpop = CookieController.readCookie(cookie_name),
            result = null;
        if (mpop && mpop.length) {
            result = mpop.split(':');
            if (result && result.length > 2) {
                return result[2];
            }
        }
        return result;
    }

    static setCookie (name, value, options) {
        options = options || {};

        var expires = options.expires;

        if (typeof expires == "number" && expires) {
            var d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        var updatedCookie = name + "=" + value;

        for (var propName in options) {
            updatedCookie += "; " + propName;
            var propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += "=" + propValue;
            }
        }
        document.cookie = updatedCookie;
    }
    static deleteCookie (name : string) {
        CookieController.setCookie(name, "", {
            expires: -1
        })
    }
}